<template>
    <div v-if="applicationMember">
        <template v-if="applicationMember.isMember || !applicationMember.member">
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('club.member.application.category.baseData') }}
            </h3>

            <!-- TITLE -->
            <kgr-form-row
                :label="$t('club.member.application.title')"
                :error="error"
                field-name="title"
            >
                <kgr-titles-select
                    v-model="applicationMember.title"
                    :club-id="clubId"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- FIRSTNAME -->
            <kgr-form-row
                :label="$t('Vorname')"
                :error="error"
                field-name="firstname"
                required
            >
                <input
                    v-model.trim="applicationMember.firstname"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Lastname -->
            <kgr-form-row
                :label="$t('Nachname')"
                :error="error"
                field-name="lastname"
                required
            >
                <input
                    v-model.trim="applicationMember.lastname"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Birthdate -->
            <kgr-form-row
                :label="$t('Geburtsdatum')"
                :error="error"
                field-name="birthdate"
                required
            >
                <kgr-date-picker
                    v-model="applicationMember.birthdate"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Gender -->
            <kgr-form-row
                :label="$t('Geschlecht')"
                :error="error"
                field-name="gender"
                required
            >
                <kgr-gender-select
                    v-model="applicationMember.gender"
                    as-input
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('club.member.application.category.contactData') }}
            </h3>

            <!-- Copy Address of Payer -->
            <div
                v-if="!applicationMember.isPayer"
                class="kgr-inputGroup"
            >
                <kgr-checkbox
                    v-model="applicationMember.copyAddressOfPayer"
                    :label="$t('Adresse vom Zahler übernehmen?')"
                />
            </div>

            <div
                v-if="!applicationMember.copyAddressOfPayer"
                class="kgr-inputGroup"
            >
                <!-- Company -->
                <kgr-form-row
                    :label="$t('Firma')"
                    :error="error"
                    field-name="company"
                >
                    <input
                        v-model.trim="applicationMember.company"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable || applicationMember.copyAddressOfPayer"
                    />
                </kgr-form-row>

                <!-- Street -->
                <kgr-form-row
                    :label="$t('Straße und Hausnummer')"
                    :error="error"
                    field-name="street"
                    required
                >
                    <input
                        v-model.trim="applicationMember.street"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable || applicationMember.copyAddressOfPayer"
                    />
                </kgr-form-row>

                <!-- C/O Address -->
                <kgr-form-row
                    :label="$t('C/O Adresse')"
                    :error="error"
                    field-name="coAddress"
                >
                    <input
                        v-model.trim="applicationMember.coAddress"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable || applicationMember.copyAddressOfPayer"
                    />
                </kgr-form-row>

                <!-- Zip -->
                <kgr-form-row
                    :label="$t('club.member.application.zip')"
                    :error="error"
                    field-name="zip"
                    required
                >
                    <input
                        v-model.trim="applicationMember.zip"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable || applicationMember.copyAddressOfPayer"
                    />
                </kgr-form-row>

                <!-- City -->
                <kgr-form-row
                    :label="$t('Ort')"
                    :error="error"
                    field-name="city"
                    required
                >
                    <input
                        v-model.trim="applicationMember.city"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable || applicationMember.copyAddressOfPayer"
                    />
                </kgr-form-row>

                <!-- Country -->
                <kgr-form-row
                    :label="$t('Land')"
                    :error="error"
                    field-name="country"
                    required
                >
                    <kgr-countries-select
                        v-model="applicationMember.countryCode"
                        :disabled="!isEditable || applicationMember.copyAddressOfPayer"
                    />
                </kgr-form-row>
            </div>

            <!-- Email -->
            <kgr-form-row
                :label="$t('E-Mail')"
                :error="error"
                field-name="email"
                required
            >
                <input
                    v-model.trim="applicationMember.email"
                    type="email"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Phone -->
            <kgr-form-row
                :label="$t('Telefon')"
                :error="error"
                field-name="phone"
                required
            >
                <input
                    v-model.trim="applicationMember.phone"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Phone Business -->
            <kgr-form-row
                :label="$t('Telefon geschäftlich')"
                :error="error"
                field-name="phoneBusiness"
                required
            >
                <input
                    v-model.trim="applicationMember.phoneBusiness"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Phone -->
            <kgr-form-row
                :label="$t('Handynummer')"
                :error="error"
                field-name="mobile"
                required
            >
                <input
                    v-model.trim="applicationMember.mobile"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Mobile Business -->
            <kgr-form-row
                :label="$t('Handynummer geschäftlich')"
                :error="error"
                field-name="mobileBusiness"
                required
            >
                <input
                    v-model.trim="applicationMember.mobileBusiness"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('club.member.application.category.contractData') }}
            </h3>
            <!-- Contract Start -->
            <kgr-form-row
                :label="$t('Gewünschtes Eintrittsdatum / Vertragsstart')"
                :error="error"
                field-name="contractStart"
                required
            >
                <kgr-date-picker
                    v-model="applicationMember.contractStart"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Passive Contract -->
            <kgr-form-row
                :label="$t('Passive Mitgliedschaft')"
                :error="error"
                field-name="passiveContractState"
            >
                <kgr-checkbox
                    v-model="applicationMember.passiveContractState"
                    class="mb1"
                    :label="$t('Passive Mitgliedschaft')"
                    :readonly="!isEditable"
                />
            </kgr-form-row>

            <!-- Departments -->
            <kgr-form-row
                v-if="config.departments"
                :label="$t('Abteilungen')"
                :error="error"
                field-name="departments"
            >
                <kgr-checkbox
                    v-for="department in config.departments"
                    :key="department.id"
                    class="mb1"
                    :checked="isDepartmentSelected(department)"
                    :label="department.name"
                    :readonly="!isEditable"
                    @change="changeDepartment(department)"
                />
            </kgr-form-row>
        </template>

        <div
            v-if="applicationMember.isPayer"
            class="kgr-inputGroup"
        >
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('Zahlungsdaten') }}
            </h3>

            <div
                v-if="usesStoredPaymentMethod"
                class="kgr-row kgr-text kgr-text--italic"
            >
                {{ $t('Es wird die im Verein hinterlegte Standard-Zahlart des Mitglieds verwendet') }}
            </div>
            <template v-else>
                <!-- Payment method selection -->
                <kgr-form-row
                    :label="$t('Zahlungsart')"
                    :error="error"
                    field-name="paymentMethod"
                >
                    <kgr-generic-radio
                        name="paymentMethod"
                        :value="paymentMethod"
                        :options="paymentMethodOptions"
                        :disabled="!isEditable"
                        @input="selectPaymentMethod"
                    />
                </kgr-form-row>

                <!-- Account Holder -->
                <kgr-form-row
                    v-if="applicationMember.sepaPayment"
                    :label="$t('Kontoinhaber')"
                    :error="error"
                    field-name="accountHolder"
                    required
                >
                    <input
                        v-model.trim="applicationMember.accountHolder"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable"
                    />
                </kgr-form-row>

                <!-- IBAN -->
                <kgr-form-row
                    v-if="applicationMember.sepaPayment"
                    :label="$t('IBAN')"
                    :error="error"
                    field-name="iban"
                    required
                >
                    <input
                        v-model.trim="applicationMember.iban"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable"
                    />
                </kgr-form-row>

                <!-- BIC -->
                <kgr-form-row
                    v-if="applicationMember.sepaPayment"
                    :label="$t('BIC')"
                    :error="error"
                    field-name="bic"
                >
                    <input
                        v-model.trim="applicationMember.bic"
                        type="text"
                        class="kgr-input"
                        :disabled="!isEditable"
                    />
                </kgr-form-row>

                <!-- Invoice Payment -->
                <kgr-form-row
                    v-if="applicationMember.sepaPayment"
                    :label="$t('Einzugsermächtigung')"
                    :error="error"
                    field-name="acceptSepa"
                    required
                >
                    <kgr-checkbox
                        v-model="applicationMember.acceptSepa"
                        class="mb1"
                        :label="$t('Einzugsermächtigung')"
                    />
                </kgr-form-row>

                <!-- Payment Interval -->
                <kgr-form-row
                    :label="$t('club.member.application.paymentInterval')"
                    :error="error"
                    field-name="paymentInterval"
                >
                    <kgr-dropdown
                        :value="getPaymentInterval"
                        :options="paymentIntervalOptions"
                        display="label"
                        :disabled="!isEditable"
                        @post-input="interval => changePaymentInterval(interval)"
                    />
                </kgr-form-row>
            </template>
        </div>

        <div
            v-if="invoiceReceiverName"
            class="kgr-inputGroup"
        >
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('Zahlungsdaten') }}
            </h3>
            <div class="kgr-alert kgr-alert--info kgr-text kgr-text--italic">
                {{ $t('Abweichender Rechnungsempfänger') }}: {{ invoiceReceiverName }}
            </div>
        </div>

        <template v-if="applicationMember.isMember || !applicationMember.member">
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('club.member.application.category.additionalData') }}
            </h3>

            <!-- Emergency Contact -->
            <kgr-form-row
                :label="$t('Notfallkontakt (Name/Nummer)')"
                :error="error"
                field-name="emergencyContact"
            >
                <input
                    v-model.trim="applicationMember.emergencyContact"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                />
            </kgr-form-row>

            <!-- Additional Information -->
            <kgr-form-row
                :label="$t('Zusätzliche Informationen')"
                :error="error"
                field-name="additionalInformation"
            >
                <textarea
                    v-model.trim="applicationMember.additionalInformation"
                    type="text"
                    class="kgr-input"
                    :disabled="!isEditable"
                ></textarea>
            </kgr-form-row>

            <!-- Family Members -->
            <kgr-form-row
                :label="$t('Familienmitglieder im Verein')"
                :error="error"
                field-name="familyMembers"
            >
                <textarea
                    v-model.trim="applicationMember.familyMembers"
                    type="text"
                    class="kgr-input"
                    :placeholder="$t('Namen und Beziehungsart (Mutter / Vater / Sohn / Tochter etc.)')"
                    :disabled="!isEditable"
                ></textarea>
            </kgr-form-row>

            <!-- FilterFlags -->
            <kgr-form-row
                v-if="applicationMember.filterFlags.length > 0"
                :error="error"
                :label="$t('Sortier- und Auswahlkriterien')"
                field-name="filterFlags"
            >
                <kgr-checkbox
                    v-for="filterFlag in applicationMember.filterFlags"
                    :key="filterFlag.id"
                    checked
                    :label="filterFlag.name"
                    class="mb1"
                    readonly
                />
            </kgr-form-row>

            <!-- Classifications -->
            <template v-if="applicationMember.classifications.length > 0">
                <kgr-form-row
                    :label="$t('Zuordnungen')"
                    :error="error"
                    field-name="filterFlags"
                >
                    <kgr-input-group
                        v-for="(classification,index) in applicationMember.classifications"
                        :key="index"
                        :label="classification.parameterValue.name"
                    >
                        <textarea
                            v-model.trim="classification.notice"
                            type="text"
                            class="kgr-input"
                            disabled
                            readonly
                        ></textarea>
                    </kgr-input-group>
                </kgr-form-row>
            </template>

            <!-- Data Protection -->
            <kgr-form-row
                :label="$t('Datenschutzrichtlinie')"
                :error="error"
                field-name="acceptDataProtection"
            >
                <kgr-checkbox
                    v-model="applicationMember.acceptDataProtection"
                    class="mb1"
                    :label="$t('Datenschutzrichtlinie')"
                    readonly
                />
            </kgr-form-row>

            <!-- Statute -->
            <kgr-form-row
                :label="$t('Satzung')"
                :error="error"
                field-name="acceptStatute"
            >
                <kgr-checkbox
                    v-model="applicationMember.acceptStatute"
                    class="mb1"
                    :label="$t('Satzung')"
                    readonly
                />
            </kgr-form-row>

            <!-- Contribution Regulations -->
            <kgr-form-row
                :label="$t('Beitragsordnung')"
                :error="error"
                field-name="acceptContributionRegulations"
            >
                <kgr-checkbox
                    v-model="applicationMember.acceptContributionRegulations"
                    class="mb1"
                    :label="$t('Beitragsordnung')"
                    readonly
                />
            </kgr-form-row>

            <!-- Uploaded files -->
            <kgr-form-row
                v-if="status !== 'accepted'"
                :label="$t('Dateiuploads')"
                :error="error"
                field-name="files"
            >
                <kgr-application-member-files
                    :is-editable="isEditable"
                    :member-files="applicationMember.files"
                    :application-member="applicationMember"
                    @update="applicationMember.files = $event"
                />
            </kgr-form-row>
            <kgr-note-box
                v-if="status === 'accepted'"
                html
                text-key="club.member.application.applicationFilesMoved.info"
                :text-params="{url: getMemberFilesLink(applicationMember)}"
            />
        </template>

        <div class="kgr-inputGroup">
            <kgr-button
                v-if="isEditable && !isReadOnlyStoredPayer"
                v-t="'Speichern'"
                type="blue"
                @click="save()"
            />
            <template v-if="applicationMember.files.length > 0">
                <kgr-button
                    v-t="'Alle Dateien als PDF herunterladen'"
                    type="grey"
                    @click="downloadAllAsPdf()"
                />
                <kgr-icon-info class="icon-info-position" />
                {{ $t('Hinweis: Dateien, die sich nicht für einen PDF-Export eignen, werden ggf. herausgefiltert.') }}
            </template>
        </div>
    </div>
</template>

<script>
import AcademicTitleSelect from '../../components/members/AcademicTitleSelect.vue';
import ApplicationMember from '../../js/dto/ApplicationMember';
import ApplicationMemberFileRepository from '../../js/repository/ApplicationMemberFileRepository';
import ApplicationMemberFiles from './ApplicationMemberFiles.vue';
import ApplicationMemberRepository from '../../js/repository/ApplicationMemberRepository';
import Checkbox from '../../components/common/form/checkbox/Checkbox.vue';
import CountriesSelect from '../../components/common/form/select/CountriesSelect.vue';
import DatePicker from '../../components/common/form/picker/DatePicker.vue';
import Dropdown from '../../components/common/form/select/Dropdown.vue';
import Error from '../../js/model/Error';
import FormRow from '../../components/common/form/FormRow.vue';
import GenderSelect from '../../components/common/form/select/GenderSelect.vue';
import GenericRadio from '../../components/common/form/radio/GenericRadio.vue';
import IconInfo from '../../components/common/icon/IconInfo.vue';
import InputGroup from '../../components/common/form/InputGroup.vue';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import MemberApplicationConfiguration from '../../js/dto/MemberApplicationConfiguration';
import NoteBox from '../../components/common/NoteBox.vue';

export default {
    components: {
        'kgr-application-member-files': ApplicationMemberFiles,
        'kgr-dropdown': Dropdown,
        'kgr-button': KgrButton,
        'kgr-form-row': FormRow,
        'kgr-gender-select': GenderSelect,
        'kgr-checkbox': Checkbox,
        'kgr-generic-radio': GenericRadio,
        'kgr-titles-select': AcademicTitleSelect,
        'kgr-date-picker': DatePicker,
        'kgr-countries-select': CountriesSelect,
        'kgr-input-group': InputGroup,
        'kgr-icon-info': IconInfo,
        'kgr-note-box': NoteBox,
    },
    props: {
        member: {
            type: ApplicationMember,
            required: true,
        },
        invoiceReceiverName: {
            type: String,
            required: false,
            default: null,
        },
        clubId: {
            type: Number,
            required: true,
        },
        config: {
            type: MemberApplicationConfiguration,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: true,
        },
        status: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            applicationMember: null,
            paymentMethod: null,
        };
    },
    computed: {
        paymentIntervalOptions() {
            return [
                {value: 'monthly', label: this.$t('monatlich')},
                {value: 'quarterly', label: this.$t('quartalsweise')},
                {value: 'half-yearly', label: this.$t('halbjährlich')},
                {value: 'yearly', label: this.$t('jährlich')}
            ];
        },
        getPaymentInterval() {
            if (this.applicationMember.paymentInterval === null) {
                return null;
            }
            return this.paymentIntervalOptions.find(element => element.value === this.applicationMember.paymentInterval);
        },
        isEditable() {
            return this.editable;
        },
        paymentMethodOptions() {
            return {
                'club.member.application.invoicePayment': 'invoice',
                'club.member.application.sepaPayment': 'sepa',
            };
        },
        usesStoredPaymentMethod() {
            return !!this.applicationMember.member
                && !this.applicationMember.invoicePayment
                && !this.applicationMember.sepaPayment;
        },
        isReadOnlyStoredPayer() {
            return this.applicationMember.member && !this.applicationMember.isMember && this.usesStoredPaymentMethod;
        },
    },
    mounted() {
        this.applicationMember = this.member;
        if (this.applicationMember.sepaPayment) {
            this.paymentMethod = 'sepa';
        } else if (this.applicationMember.invoicePayment) {
            this.paymentMethod = 'invoice';
        }
    },
    methods: {
        save() {
            this.error = new Error();
            ApplicationMemberRepository.update(this.applicationMember)
                .then(() => this.$notify.success('saveChanges.success'))
                .catch((error) => {
                    this.$notify.error('saveChanges.error');
                    this.error = error;
                });
        },
        downloadAllAsPdf() {
            ApplicationMemberFileRepository.checkDownloadAll(this.applicationMember.id)
                .then((response) => {
                    if (response.data.convertibleFilesCount === 0) {
                        this.$notify.warning('Ihr Download enthält keine Dateien, die sich in ein PDF wandeln lassen.');
                        return;
                    }
                    if (response.data.notConvertibleFiles.length > 0) {
                        this.$notify.warning('Ihr Datei-Download startet sofort, allerdings sind folgende Dateien nicht im Download enthalten, weil sie sich nicht in ein PDF wandeln lassen: {files}', {files: response.data.notConvertibleFiles.join(', ')});
                    }
                    ApplicationMemberFileRepository.downloadAll(this.applicationMember.id);
                })
        },
        changeDepartment(department) {
            if (this.isDepartmentSelected(department)) {
                this.applicationMember.departments = this.applicationMember.departments.filter(element => element.id !== department.id);
            } else {
                this.applicationMember.departments.push(department);
            }
        },
        isDepartmentSelected(department) {
            return this.applicationMember.departments.filter(element => element.id === department.id).length > 0;
        },
        changePaymentInterval(paymentInterval) {
            if (!paymentInterval) {
                this.applicationMember.paymentInterval = null;
                return;
            }
            this.applicationMember.paymentInterval = paymentInterval.value;
        },
        selectPaymentMethod(method) {
            this.paymentMethod = method;
            this.applicationMember.invoicePayment = method === 'invoice';
            this.applicationMember.sepaPayment = method === 'sepa';
            if (method !== 'sepa') {
                // Drop SEPA mandate data when not paying by SEPA.
                this.applicationMember.accountHolder = null;
                this.applicationMember.iban = null;
                this.applicationMember.bic = null;
                this.applicationMember.acceptSepa = false;
            }
        },
        getMemberFilesLink(applicationMember) {
            if (applicationMember.member === null) {
                return null;
            }
            return `/backend/clubs/members/${applicationMember.member}/files`;
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.icon-info-position {
    vertical-align: text-bottom;
}
</style>
